declare const window: Window & {
  webkit?: any;
};

export function iOSPushCapability(): boolean {
  return !!(
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers['push-permission-request'] &&
    window.webkit.messageHandlers['push-permission-state']
  );
}

export function iOSPushPostMessage(): void {
  try {
    window.webkit.messageHandlers['push-token'].postMessage('push-token');
  } catch (err) {
    console.log('Can not reach native code');
  }
}
